// Theme: summer-heat-noir
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'summer-heat-noir',
  name: 'SUMMER HEAT NOIR',
  tagline: 'SUMMER HEAT NOIR',
  description: 'Recolor noir do summer heat com assinatura carmim escura.',
  category: 'organic-world',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A0E0A', '#E11D48', '#2A1810', '#FFD1B8'],
  familyId: 'summer-heat',
  variantName: 'NOIR',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-summer-heat-noir'
  },
  colorVars: {
    '--accent': '#E11D48',
    '--accent-foreground': '#1A0E0A',
    '--background': '#1A0E0A',
    '--border': '#7A3A20',
    '--card': '#2A1810',
    '--card-border-active': 'rgba(225, 29, 72, 0.48)',
    '--card-completed': '#2A1810',
    '--card-foreground': '#FFD1B8',
    '--card-glow': 'rgba(225, 29, 72, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0E0A',
    '--foreground': '#FFD1B8',
    '--hold-fill': '#E11D48',
    '--input': '#2A1810',
    '--modal-bg': '#1A0E0A',
    '--modal-border': '#7A3A20',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A3A20',
    '--muted-foreground': '#FFD1B8',
    '--nav-active': '#E11D48',
    '--nav-bg': '#1A0E0A',
    '--popover': '#2A1810',
    '--popover-foreground': '#FFD1B8',
    '--primary': '#E11D48',
    '--primary-foreground': '#1A0E0A',
    '--ring': '#E11D48',
    '--secondary': '#7A3A20',
    '--secondary-foreground': '#FFD1B8',
    '--streak': '#E11D48',
    '--success': '#22C55E',
    '--success-foreground': '#1A0E0A',
    '--xp': '#E11D48',
    '--xp-bg': '#2A1810'
  },
  resolvedVars: {
    '--accent': '#E11D48',
    '--accent-foreground': '#1A0E0A',
    '--accent-foreground-hsl': '15 44% 7%',
    '--accent-foreground-oklch': 'from #1A0E0A l c h',
    '--accent-hsl': '347 77% 50%',
    '--accent-oklch': 'from #E11D48 l c h',
    '--background': '#1A0E0A',
    '--background-hsl': '15 44% 7%',
    '--background-oklch': 'from #1A0E0A l c h',
    '--border': '#7A3A20',
    '--border-hsl': '17 58% 30%',
    '--border-oklch': 'from #7A3A20 l c h',
    '--border-w': '1px',
    '--card': '#2A1810',
    '--card-border-active': 'rgba(225, 29, 72, 0.48)',
    '--card-completed': '#2A1810',
    '--card-completed-hsl': '18 45% 11%',
    '--card-completed-oklch': 'from #2A1810 l c h',
    '--card-foreground': '#FFD1B8',
    '--card-foreground-hsl': '21 100% 86%',
    '--card-foreground-oklch': 'from #FFD1B8 l c h',
    '--card-glow': 'rgba(225, 29, 72, 0.1)',
    '--card-hsl': '18 45% 11%',
    '--card-oklch': 'from #2A1810 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0E0A',
    '--destructive-foreground-hsl': '15 44% 7%',
    '--destructive-foreground-oklch': 'from #1A0E0A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FFD1B8',
    '--foreground-hsl': '21 100% 86%',
    '--foreground-oklch': 'from #FFD1B8 l c h',
    '--hold-fill': '#E11D48',
    '--hold-fill-hsl': '347 77% 50%',
    '--hold-fill-oklch': 'from #E11D48 l c h',
    '--input': '#2A1810',
    '--input-hsl': '18 45% 11%',
    '--input-oklch': 'from #2A1810 l c h',
    '--modal-bg': '#1A0E0A',
    '--modal-bg-hsl': '15 44% 7%',
    '--modal-bg-oklch': 'from #1A0E0A l c h',
    '--modal-border': '#7A3A20',
    '--modal-border-hsl': '17 58% 30%',
    '--modal-border-oklch': 'from #7A3A20 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A3A20',
    '--muted-foreground': '#FFD1B8',
    '--muted-foreground-hsl': '21 100% 86%',
    '--muted-foreground-oklch': 'from #FFD1B8 l c h',
    '--muted-hsl': '17 58% 30%',
    '--muted-oklch': 'from #7A3A20 l c h',
    '--nav-active': '#E11D48',
    '--nav-active-hsl': '347 77% 50%',
    '--nav-active-oklch': 'from #E11D48 l c h',
    '--nav-bg': '#1A0E0A',
    '--nav-bg-hsl': '15 44% 7%',
    '--nav-bg-oklch': 'from #1A0E0A l c h',
    '--popover': '#2A1810',
    '--popover-foreground': '#FFD1B8',
    '--popover-foreground-hsl': '21 100% 86%',
    '--popover-foreground-oklch': 'from #FFD1B8 l c h',
    '--popover-hsl': '18 45% 11%',
    '--popover-oklch': 'from #2A1810 l c h',
    '--primary': '#E11D48',
    '--primary-foreground': '#1A0E0A',
    '--primary-foreground-hsl': '15 44% 7%',
    '--primary-foreground-oklch': 'from #1A0E0A l c h',
    '--primary-hsl': '347 77% 50%',
    '--primary-oklch': 'from #E11D48 l c h',
    '--radius': '12px',
    '--ring': '#E11D48',
    '--ring-hsl': '347 77% 50%',
    '--ring-oklch': 'from #E11D48 l c h',
    '--secondary': '#7A3A20',
    '--secondary-foreground': '#FFD1B8',
    '--secondary-foreground-hsl': '21 100% 86%',
    '--secondary-foreground-oklch': 'from #FFD1B8 l c h',
    '--secondary-hsl': '17 58% 30%',
    '--secondary-oklch': 'from #7A3A20 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#E11D48',
    '--streak-hsl': '347 77% 50%',
    '--streak-oklch': 'from #E11D48 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#1A0E0A',
    '--success-foreground-hsl': '15 44% 7%',
    '--success-foreground-oklch': 'from #1A0E0A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(347 77% 50% / 0.15)',
    '--xp': '#E11D48',
    '--xp-bg': '#2A1810',
    '--xp-bg-hsl': '18 45% 11%',
    '--xp-bg-oklch': 'from #2A1810 l c h',
    '--xp-hsl': '347 77% 50%',
    '--xp-oklch': 'from #E11D48 l c h'
  }
}
